import React from "react";
import { Grid } from "@material-ui/core";
import StepCircle from "./StepCircle";
import StepDescription from "./StepDescription";

export default function OrderStatus({ status }) {
    return (
        <Grid
            container
            justify="space-between"
            alignItems="center"
            wrap="nowrap"
            className="steps-container"
        >
            <StepCircle
                step={1}
                active={status}
                current={status}
                activeStatuses={["submitted", "unpaid", "paid"]}
                currentStatuses={["submitted"]}
            />
            <StepDescription
                top="Проверка заказа"
                bottom="менеджером"
                current={status === "submitted"}
            />
            <StepCircle
                step={2}
                active={status}
                current={status}
                activeStatuses={["unpaid", "paid"]}
                currentStatuses={["submitted", "unpaid"]}
            />
            <StepDescription
                top="Оплата"
                bottom="заказа"
                current={status === "unpaid"}
            />
            <StepCircle
                step={3}
                active={status}
                current={status}
                activeStatuses={["paid"]}
                currentStatuses={["submitted", "unpaid", "paid"]}
            />
            <StepDescription
                top="Проверка поступления"
                bottom="денег"
                current={status === "paid"}
            />
            <StepCircle
                step={4}
                active={status}
                current={status}
                activeStatuses={[]}
                currentStatuses={["paid"]}
            />
        </Grid>
    );
}



// WEBPACK FOOTER //
// ./src/Order/OrderStatus.jsx